import componentFn from '../../styles/objects/component'
export default ({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
}) => {
    const component = componentFn({
        colors,
        spacings,
        images,
        fontFamilies,
        fontWeights,
        fontSizes,
        textTransforms
    })
    const styles = {

        try: {
            border: 'none',
            borderBottom: '2px solid #bab7cc',
            borderBottomStyle: 'solid',
            borderRadius: '0px'
        },
        labelActive:{
            fontWeight: '800',
            position: 'relative',
             color: '#00B7FF',//'#00a5ff',
            fontSize: '.75rem',
            top: '0',
            display: 'block',
            visibility: 'visible'
          },
          divmain:{
              paddingTop:'10px'
          }
      }
return { ...component, ...styles }
}




// WEBPACK FOOTER //
// ./components/selectsearch/styles.js